// GDPR consent core + Google Consent Mode v2 gating.
// Necessary cookies are always on. Analytics defaults to DENIED and is only
// upgraded to GRANTED after the user explicitly accepts. "Decline" is given
// equal weight to "Accept". The stored choice can be changed at any time by
// re-opening the banner via the "Cookie settings" trigger.
const $ce7c5117552d1b85$var$STORAGE_KEY = "analytics-consent";
function $ce7c5117552d1b85$var$gtagConsentUpdate(state) {
    // Push directly to dataLayer so this works even if the gtag stub
    // has not finished initialising. Consent Mode reads from dataLayer.
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === "function") window.gtag("consent", "update", {
        analytics_storage: state,
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied"
    });
    else window.dataLayer.push([
        "consent",
        "update",
        {
            analytics_storage: state,
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied"
        }
    ]);
}
function $ce7c5117552d1b85$var$getStoredConsent() {
    const value = window.localStorage.getItem($ce7c5117552d1b85$var$STORAGE_KEY);
    if (value === "granted" || value === "denied") return value;
    return null;
}
function $ce7c5117552d1b85$var$storeConsent(state) {
    window.localStorage.setItem($ce7c5117552d1b85$var$STORAGE_KEY, state);
}
window.addEventListener("DOMContentLoaded", ()=>{
    const banner = document.querySelector("#cookiebanner");
    if (!banner) return;
    const acceptButton = banner.querySelector("#cookie-accept");
    const declineButton = banner.querySelector("#cookie-decline");
    const showBanner = ()=>{
        banner.style.display = "flex";
        banner.removeAttribute("hidden");
        acceptButton?.focus();
    };
    const hideBanner = ()=>{
        banner.style.display = "none";
        banner.setAttribute("hidden", "");
    };
    const applyChoice = (state)=>{
        $ce7c5117552d1b85$var$storeConsent(state);
        $ce7c5117552d1b85$var$gtagConsentUpdate(state);
        hideBanner();
    };
    // Allow users to revisit their choice from a footer "Cookie settings" link.
    window.openCookieSettings = showBanner;
    acceptButton?.addEventListener("click", ()=>applyChoice("granted"));
    declineButton?.addEventListener("click", ()=>applyChoice("denied"));
    const stored = $ce7c5117552d1b85$var$getStoredConsent();
    if (stored === null) // No prior decision: analytics stays denied (set as default in <head>)
    // and the banner is shown so the user can make an informed choice.
    showBanner();
    else {
        // Re-apply the saved decision on every load.
        $ce7c5117552d1b85$var$gtagConsentUpdate(stored);
        hideBanner();
    }
});


//# sourceMappingURL=blog.5e75d17d.js.map
